export default __webpack_public_path__ + "static/media/blockBorder.5ad50d04.jpg";